<template>
  <div
    class="md-dialog-container md-dialog-fullscreen md-theme-default"
    tabindex="-1"
  >
    <div class="md-layout">
      <div class="pdf-marco">
        <div ref="pdf12"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruta: ""
    };
  },
  created() {
    let script = document.createElement("script");
    script.src = "https://unpkg.com/pdfobject@2.2.4/pdfobject.min.js";
    document.head.appendChild(script);
    script.addEventListener("load", () => {
      this.ruta = `${process.env.VUE_APP_PUBLIC_PATH}/images/especificaciones_tecnicas_para_instalacion_de_registradores_acelerometricos.pdf`;
      PDFObject.embed(this.ruta, this.$refs.pdf12);
    });
  }
};
</script>
<style scoped>
.pdf-hojas {
  display: grid;
  width: 100%;
}
.pdf-marco {
  width: 100%;
  height: 500px;
  overflow-y: auto;
}
.pdf-marco > span:not(:last-child) {
  margin-bottom: 10px;
}
.pdf-marco > div {
  height: 100%;
  width: 100%;
}
.pdf-marco > div > embed {
  overflow: auto;
  width: 100%;
  height: 100%;
}
@media (max-width: 590px) {
  .pdf-marco {
    height: 100vh;
  }
}
</style>
